__turbopack_context__.v({
  "boostedTagIcon": "HXeISW_boostedTagIcon",
  "boostedTagText": "HXeISW_boostedTagText",
  "gradientOverlay": "HXeISW_gradientOverlay",
  "priceContainer": "HXeISW_priceContainer",
  "productAttributesContainer": "HXeISW_productAttributesContainer",
  "soldText": "HXeISW_soldText",
  "translucentHoverOverlay": "HXeISW_translucentHoverOverlay",
});
